import { IconButton } from "@circleco/compass/components/IconButton";
import { Menu } from "@circleco/compass/components/Menu";

import { t } from "@/i18n-js/instance";

import type { ParticipantActionsDropdownProps } from "./types";

export const ParticipantActionsDropdownComponent = ({
  options,
}: ParticipantActionsDropdownProps) => (
  <div
    className="hidden group-hover:block has-[[data-popup-open]]:block"
    onClick={e => e.stopPropagation()}
    onKeyDown={e => e.stopPropagation()}
    aria-hidden="true"
  >
    <Menu
      align="start"
      side="bottom"
      options={options}
      trigger={
        <IconButton
          icon="dot-menu"
          variant="ghost"
          size="sm"
          aria-label={t("chat_space.view_member_actions")}
        />
      }
    />
  </div>
);
